"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TransactionStatus = void 0;
var TransactionStatus;
(function (TransactionStatus) {
    TransactionStatus["NEW"] = "NEW";
    TransactionStatus["PENDING"] = "PENDING";
    TransactionStatus["PROCESS"] = "PROCESS";
    TransactionStatus["PROCESSED"] = "PROCESSED";
})(TransactionStatus || (exports.TransactionStatus = TransactionStatus = {}));
//# sourceMappingURL=transaction.js.map